module.exports = __webpack_public_path__ + "img/cert-back.aa622246.svg";